import { useContext } from "react";
import { ApartmentViewContext } from "../context/ApartmentViewContext";
import styles from "../../../styles/aprt.module.scss";

function CompartmentsList({
  IndoorCompartmentsList,
  OutdoorCompartmentsList,
  forcedSecondColumn,
  maximumRowsNumber,
}) {

  const { isFloorPlanInteractive } = useContext(ApartmentViewContext);
  const customGridRows = {
    "--custom-grid-template-rows": `repeat(${maximumRowsNumber}, minmax(19px, auto))`,
    "--custom-cursor": isFloorPlanInteractive ? "pointer" : "default",
  };

  return (
    <dl className={styles.compartmentsList__list} style={customGridRows}>
      {IndoorCompartmentsList}
      {/* <div
        className={`
          ${styles.list__divider} 
          ${forcedSecondColumn ? styles.list__forcedSecondColumn : ""}
          `}
      /> */}
      {OutdoorCompartmentsList}
    </dl>
  );
}

export default CompartmentsList;
